import React from 'react';
import AppModal from '../../components/UI/Modal';
import RenderOrderDetails from './RenderOrderDetails';
import { dateTime, numberLabel } from './orderView';

export default function OrderDetailsModal({ page, onClose }) {
  const order = page.detail?._id === page.selectedId ? page.detail : null;
  return <AppModal
    show size="xl" handleClose={onClose} closeButton={false}
    preventOutsideClose keyboard={false}
    className="orders-modal orders-card-modal"
    backdropClassName="orders-card-modal-backdrop"
    titleId="order-card-title"
    modalTitle={<div className="orders-card-modal__title"><div>
      <small>Карточка заказа</small>
      <h2 id="order-card-number">{order ? numberLabel(order) : 'Загрузка заказа…'}</h2>
      {order && <p>{dateTime(order.createdAt)} · {order.officeId?.name || 'Личный заказ'}</p>}
    </div><button type="button" className="orders-close" disabled={page.busy} onClick={onClose} aria-label="Закрыть карточку заказа">×</button></div>}
    footer={<><button type="button" className="orders-btn" disabled={page.busy || page.detailLoading} onClick={page.refresh}>Обновить карточку</button><button type="button" className="orders-btn" disabled={page.busy} onClick={onClose}>Закрыть</button></>}
  >
    <div className="orders-card-modal__feedback">
      {page.notice && <div className="orders-message orders-message--success" role="status">{page.notice}</div>}
      {page.detailError && <div className="orders-message orders-message--danger" role="alert">{page.detailError}</div>}
      {page.detailLoading && <div className="orders-empty" role="status">{order ? 'Обновление карточки…' : 'Загрузка карточки заказа…'}</div>}
    </div>
    {order && <RenderOrderDetails key={order._id} order={order} busy={page.busy || page.detailLoading} mutate={page.mutate} onPaymentSaved={page.refreshDetail} onPaymentBusy={page.lockPayment} />}
  </AppModal>;
}
